const ArrowDownCircleFill = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM12.4873 16.967C12.36 17.0999 12.184 17.175 12 17.175C11.816 17.175 11.64 17.0999 11.5127 16.967L7.76265 13.054C7.50471 12.7848 7.51381 12.3575 7.78296 12.0996C8.05211 11.8417 8.4794 11.8508 8.73734 12.1199L11.325 14.8201V7.5C11.325 7.12721 11.6272 6.825 12 6.825C12.3728 6.825 12.675 7.12721 12.675 7.5V14.8201L15.2627 12.1199C15.5206 11.8508 15.9479 11.8417 16.217 12.0996C16.4862 12.3575 16.4953 12.7848 16.2373 13.054L12.4873 16.967Z"
      fill="#31D158"
    />
  </>
);

export default ArrowDownCircleFill;
